import React from "react";

import { Carousel } from "../SKSCarousel";

import styles from "./index.module.scss";

type CenterFocusedImage = {
    id: number;
    url: string;
    alt: string;
};

export const CenterFocusedCarousel = (props: {
    label: string;
    images: CenterFocusedImage[];
    caption?: (activeIndex: number) => React.ReactNode;
}) => {
    const scrollRef = React.useRef<HTMLDivElement>(null);
    const [activeIndex, setActiveIndex] = React.useState(0);

    const handleActiveChange = React.useCallback(
        (activeIndexes: Set<number>) => {
            const first = activeIndexes.values().next();
            if (!first.done) {
                setActiveIndex(first.value);
            }
        },
        [],
    );

    const captionContent = props.caption?.(activeIndex);

    React.useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            const firstSlide = el.querySelector<HTMLElement>(
                "[data-slide-index='0']",
            );
            if (!firstSlide) return;
            const scrollLeft =
                firstSlide.offsetLeft -
                (el.clientWidth / 2 - firstSlide.offsetWidth / 2);
            el.scrollTo({ left: scrollLeft, behavior: "instant" });
        });
    }, []);

    return (
        <>
            <Carousel
                label={props.label}
                loop={false}
                advanceBy="item"
                onActiveChange={props.caption ? handleActiveChange : undefined}
                dotsClassName={styles.carouselDots}
                controlsClassName={styles.carouselControls}
                containerProps={{
                    className: styles.carousel,
                }}
                scrollContainerProps={{
                    className: styles.carouselScroll,
                    ref: scrollRef,
                }}
                slideWrapperProps={{
                    className: styles.carouselSlidesWrapper,
                }}
                slideContainerProps={{
                    className: styles.carouselSlide,
                }}
            >
                {props.images.map((image) => (
                    <img
                        key={image.id}
                        src={image.url}
                        alt={image.alt}
                        className={styles.carouselImage}
                    />
                ))}
            </Carousel>
            {captionContent && (
                <div className={styles.caption}>{captionContent}</div>
            )}
        </>
    );
};
